import FinancialRiskLevelDropdown from "components/dropdowns/reactselect/FinancialRiskLevelDropdown";
import OptionalTextAreaInput from "components/ValidatedFields/OptionalTextAreaInput";
import React from "react";
import { getFinancialRiskLevel } from "utilities/enumutils";
interface Props {
  value: server.dto.FinancialRisk;
  onChange: (value: server.dto.FinancialRisk) => void;
}

export const FinancialRiskEdit = (props: Props) => {
  const financialRiskLevel = getFinancialRiskLevel(props.value.level);
  return <div className="flex-column gap">
    <div>
      <FinancialRiskLevelDropdown
        value={financialRiskLevel}
        onChange={level => props.onChange({ ...props.value, level: level.value })}
        config={{
          focusOnMount: true,
          openMenuOnFocus: true
        }}
      />
    </div>
    {props.value.level !== "unknown" && <div>
      <OptionalTextAreaInput
        maxLength={serverReference.constants.company.financialRiskCommentMaxLength}
        rows={3}
        value={props.value.comment ?? ""}
        onChange={comment => props.onChange({ ...props.value, comment })}
        placeholder={RESX.GeneralLabels.Comment}
      />
    </div>}
  </div>
}